module.exports = __webpack_public_path__ + "img/Donut.cb34f0bd.webp";